<template>
  <div class="sign">
    <div class="sign-search">
      <div class="btn-box">
        <van-field
          size="small"
          v-model="containerNoOrSku"
          placeholder="请扫码SKU/输入装车单号"
          right-icon="scan"
          @click-right-icon="scanSku"
          :formatter="relationNumberFmt"
          @keyup.13="getList()"
          @input="triggerSearch"
          ref="scanInp"
        />
      </div>
      <div class="toSearch-box">
        <button class="sign-toSearch" ref="searchBtn" @click="getList()">
          查询
        </button>
      </div>
    </div>

    <div class="sign-item">
      <ul class="bale-container">
        <li>
          <div>装车单号</div>
          <div>参考单号</div>
          <div>预计装车时间</div>
        </li>
        <template v-if="startSearch">
          <van-loading size="24px" vertical>加载中...</van-loading>
        </template>
        <template v-else>
          <template v-if="list.length">
            <li
              @click="toDetail(item)"
              v-for="(item, index) in list"
              :key="index"
            >
              <div>{{ item.loadCarNo }}</div>
              <div>{{ item.referenceNo }}</div>
              <div>{{ item.deliveryDateDesc }}</div>
            </li>
          </template>
          <template v-else>
            <van-empty image="search" description="暂无数据" />
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
} from "vant";
import { GetWaitPutOnCarListByContainerNoOrSku } from "@/api/mobile/loading_api";
import { mapState, mapMutations } from "vuex";
import util from "util/date";
import { debounce } from "util/util";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      containerNoOrSku: "",
      list: [],
      startSearch: false,
      tabType: "sku",
    };
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  computed: {
    ...mapState({ warehouse: (state) => state.common.warehouse }),
  },

  mounted() {},

  methods: {
    ...mapMutations({}),

    init() {
      // const _warehouse = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse) : this.warehouse;
      // this.$set(this.search, 'warehouseId', _warehouse.warehouseId)

      this.getList();
    },

    triggerSearch() {
      this.$refs.searchBtn.click();
    },

    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.containerNoOrSku = a.resultStr;
          that.getList();
        },
      });
    },

    getList() {
      const _warehouse = JSON.parse(window.localStorage.warehouse);

      const data = {
        LoadCarNoOrReferenceNoOrSku: this.containerNoOrSku,
        WarehouseId: _warehouse.warehouseId,
        transportType: this.$route.query.transportType,
      };

      this.startSearch = true;
      this.list = [];

      GetWaitPutOnCarListByContainerNoOrSku(data).then((res) => {
        this.startSearch = false;
        if (res.status === 200) {
          const { response } = res;

          if (!response.length) Toast("暂无匹配数据");

          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    toDetail(item) {
      if (item.status == 10) {
        Toast("需打印装车单才允许操作");
        return false;
      }
      const { loadCarInfoID } = item;
      this.$router.push({
        path: "/mobile/loadingDetail",
        query: { loadCarInfoID },
      });
    },

    relationNumberFmt(v) {
      return v.trim();
    },
  },

  watch: {
    $route: async function (newValue, from) {
      this.$nextTick(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.sign-search {
  justify-content: center;
  padding: 20px 20px 15px 20px;
}

.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 55px;
}

.sign-search .btn-box {
  flex: 0.8;
}

::v-deep .van-cell {
  padding: 10px 16px;
}

.sign-toSearch {
  width: 100%;
  height: 51%;
  min-height: 46px;
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 20px;
}

::v-deep .van-tabs__nav--card {
  margin: 0;
  border: 0;
}

.sign-item .bale-container li {
  display: flex;
  height: 40px;
  line-height: 40px;
  & > div {
    flex: 1;
    text-align: center;
  }
}
</style>